import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import { api } from "../../../config";
import defaultImg from "../../../assets/images/upload.png";

//Import actions
import { resetTicketCategoryState, getTicketCategory } from "../../../store/ticketCategory/action";
import { resetClientState, getClient } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { getTicket as onGetTickets, addNewTicket as onAddNewTicket, updateTicket as onUpdateTicket, deleteTicket as onDeleteTicket, getTicketLoading, resetTicketState } from "../../../store/ticket/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ModalInputFile from "../../../Components/ModalInputFile";

const Ticket = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientLoading, clients, tickets, isTicketCreated, isTicketSuccess, loading, error, companies, companyLoading, positions, positionLoading, ticketCategories, ticketCategoryLoading } = useSelector((state) => ({
    tickets: state.Ticket.tickets,
    isTicketCreated: state.Ticket.isTicketCreated,
    isTicketSuccess: state.Ticket.isTicketSuccess,
    loading: state.Ticket.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.Ticket.error,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    ticketCategories: state.TicketCategory.ticketCategories,
    ticketCategoryLoading: state.TicketCategory.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [ticketList, setTicketList] = useState([]);
  const [ticket, setTicket] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [ticketDetail, setTicketDetail] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [companyName, setCompanyName] = useState({});
  const [logo, setLogo] = useState(defaultImg);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [ticketCategoryList, setTicketCategoryList] = useState([]);
  const [otherDocImg, setOtherDocImg] = useState([]);
  const [modalMedia, setModalMedia] = useState(false);
  const [originalFiles, setOriginalFiles] = useState([]);
  const ref = useRef(null);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const onClickDelete = (ticket) => {
    setTicket(ticket);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (ticketDetail) => {
    setTicketDetail(ticketDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteTicket = () => {
    if (ticket) {
      dispatch(onDeleteTicket(ticket));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (employee) => {
    setTicket(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredTickets = tickets;
      if (type !== "all") {
        filteredTickets = tickets.filter((ticket) => ticket.ticket_status.name === type);
      }
      setTicketList(filteredTickets);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsEdit(false);
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`);
        setClientSelect({ label: obj.data.client_name, value: obj.data.clientId });
        setCompanySelect({ label: obj.data.company_name, value: obj.data.companyId });

        dispatch(resetTicketState());
        dispatch(onGetTickets());
        dispatch(resetTicketCategoryState());
        dispatch(getTicketCategory());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
        handleGetPosition(obj.data.companyId);
      }
    }
  }, [dispatch, isSearch]);

  useEffect(() => {
    if (!isEmpty(tickets)) {
      setIsEdit(false);
      let filteredTickets = tickets;
      if (activeTypeTab !== "all") {
        filteredTickets = tickets.filter((ticket) => ticket.ticket_status.name === activeTypeTab);
      }
      setTicketList(filteredTickets);
      let current = 0;
      setInfo(tickets[current]);
    }
  }, [tickets]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(ticketCategories)) {
      var data = [];
      var opt = [];
      ticketCategories.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setTicketCategoryList(data);
    }
  }, [ticketCategories]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    positions.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const departmentId = item.departmentId;
      var obj = { label: name, value: id, departmentId: departmentId };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (positions.length > 0) {
      setPositionList(data);
    }
  }, [positions]);

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleSelectFile = (file) => {
    setOtherDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);

    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = otherDocImg.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setOtherDocImg(newState);
    } else {
      const index = otherDocImg.findIndex((fl) => fl.filename === file.filename);
      setOtherDocImg((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setOriginalFiles([]);
      setOtherDocImg([]);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleTicketClick = useCallback(
    (arg) => {
      const data = arg;

      let files = [];

      if (data.ticket_file.length > 0) {
        data.ticket_file.forEach((element) => {
          files.push({
            filename: element.filename,
          });
        });
      }

      setOtherDocImg(files);

      setTicket({
        id: data.id,
        name: data.name,
        isVehicle: data.isVehicle,
        description: data.description,
        client: data.ticket_client && {
          label: data.ticket_client ? data.ticket_client.name : "",
          value: data.ticket_client ? data.ticket_client.id : "",
        },
        company: data.ticket_company && {
          label: data.ticket_company ? data.ticket_company.name : "",
          value: data.ticket_company ? data.ticket_company.id : "",
        },
        position: data.ticket_position && {
          label: data.ticket_position ? data.ticket_position.name : "",
          value: data.ticket_position ? data.ticket_position.id : "",
        },
        category: data.ticket_category && {
          label: data.ticket_category ? data.ticket_category.name : "",
          value: data.ticket_category ? data.ticket_category.id : "",
        },
        status: data.ticket_status && {
          label: data.ticket_status ? data.ticket_status.name : "",
          value: data.ticket_status ? data.ticket_status.id : "",
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={`btn-sm ${userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").includes("updateTicket")) ? "" : "d-none"}`}
                    onClick={() => {
                      handleTicketClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={`btn-sm ${userType === "admin" || userType === "client" || userType === "company" || (userRole && userRole.split(",").includes("deleteTicket")) ? "" : "d-none"}`}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Diajukan Oleh",
        accessor: "ticket_requestedby.name",
        filterable: true,
        Cell: (cell) => <span>{cell.row.original.ticket_requestedby.name}</span>,
      },
      {
        Header: "Diajukan Untuk",
        accessor: "ticket_position.name",
        filterable: true,
      },
      {
        Header: "Judul",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: `Status`,
        accessor: "ticket_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [handleTicketClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: ticketList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (ticket && ticket.name) ?? "",
      client: (ticket && ticket.client) || clientSelected,
      company: (ticket && ticket.company) || companySelected,
      category: (ticket && ticket.category) ?? "",
      position: ticket && ticket.position,
      isVehicle: (ticket && ticket.isVehicle) || false,
      description: (ticket && ticket.description) ?? "",
      file: (ticket && ticket.file) || [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Ticket Name").nullable(true),
      // position: Yup.object().required("Please Enter Position Name").nullable(true),
      // company: Yup.object().required("Please Enter Company").nullable(true),
      // description: Yup.string().required("Please Enter Percentage Value").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getTicketLoading());
      if (isEdit) {
        const updateTicket = {
          id: ticket ? ticket.id : 0,
          name: values.name,
          description: values.description,
          isVehicle: values.isVehicle,
          positionId: values.position.value,
          departmentId: values.position.departmentId,
          clientId: values.client.value,
          companyId: values.company.value,
          ticketCategoryId: values.category.value,
          statusId: 2,
          files: otherDocImg.length > 0 ? otherDocImg : [],
        };
        dispatch(onUpdateTicket(updateTicket));
        validation.resetForm();
      } else {
        const newTicket = {
          name: values.name,
          description: values.description,
          isVehicle: values.isVehicle,
          positionId: values.position.value,
          departmentId: values.position.departmentId,
          clientId: values.client.value,
          companyId: values.company.value,
          ticketCategoryId: values.category.value,
          statusId: 2,
          files: otherDocImg.length > 0 ? otherDocImg : [],
        };
        dispatch(onAddNewTicket(newTicket));
        validation.resetForm();
      }
      toggle();
    },
  });

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetTickets(param));
  }

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetPosition = (id) => {
    dispatch(resetPositionState());
    dispatch(getPosition({ companyId: id }));
  };

  useEffect(() => {
    setCompanyList([]);
    setPositionList([]);
    return () => {
      dispatch(resetCompanyState());
      dispatch(resetPositionState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  document.title = "Permintaan Pekerjaan | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteTicket} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Tickets" pageTitle="Task" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Permintaan Pekerjaan &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createTicket") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                      id="create-btn"
                      onClick={() => {
                        setIsEdit(false);
                        toggle();
                      }}
                    >
                      <i className="ri-coupon-line me-1 align-bottom fs-14"></i> Tambah
                    </button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-coupon-line me-1 align-bottom fs-14"></i> Semua Order
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> Open
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> Processed
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> Closed
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={7}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col className="col-xxl-3">
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Order Kerja" : "Tambah Order Kerja"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-4">
                          <div className="mb-3 ">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;{" "}
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                setCompanyList([]);
                                validation.setFieldValue("company", "");
                                validation.setFieldValue("client", e);
                                handleGetCompany(e.value);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;{" "}
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="position-field" className="form-label">
                              Permintaan Pekerjaan Ditujukan Untuk&nbsp;
                              {positionLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="position"
                              value={validation.values.position}
                              placeholder="Pilih Posisi"
                              onChange={(e) => {
                                validation.setFieldValue("position", e);
                              }}
                              options={positionList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="category-field" className="form-label">
                              Kategori Permintaan Pekerjaan &nbsp;
                              {ticketCategoryLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="category"
                              value={validation.values.category}
                              placeholder="Pilih Kategori"
                              onChange={(e) => {
                                validation.setFieldValue("category", e);
                              }}
                              options={ticketCategoryList}
                            ></Select>
                          </div>
                        </div>
                        <div className="mb-3 col-lg-8">
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama Permintaan Pekerjaan
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Judul Tiket" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Input name="isVehicle" id="isVehicle-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isVehicle} /> &nbsp;
                            <Label htmlFor="isVehicle-field" className="form-label">
                              Terkait Permintaan Kendaraan
                            </Label>
                          </div>
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="education" className="form-label">
                              Dokumen Terkait (Jika ada)
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                toggleMedia();
                              }}
                            >
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {otherDocImg.map((otherDocFile, i) => {
                            if (otherDocFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={otherDocFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${otherDocFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{otherDocFile.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          handleDeleteFile(otherDocFile);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                          <div className="mb-3">
                            <Label htmlFor="description-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="description-field" rows="7" className="form-control" placeholder="Uraian Permintaan Pekerjaan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ticket;
